/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete-trash': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<path pid="0" d="M9.375.625c.69 0 1.25.56 1.25 1.25V2.5H12.5c.69 0 1.25.56 1.25 1.25V5c0 .69-.56 1.25-1.25 1.25h-.051l-.574 6.875c0 .69-.56 1.25-1.25 1.25h-6.25c-.69 0-1.25-.56-1.248-1.198L2.55 6.25H2.5c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25h1.875v-.625c0-.69.56-1.25 1.25-1.25h3.75zm1.82 5.625h-7.39l.57 6.875h6.25l.002-.052.569-6.823zm1.305-2.5h-10V5h10V3.75zM9.375 1.875h-3.75V2.5h3.75v-.625z" _fill="#EF4136" fill-rule="evenodd"/>'
  }
})
